import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ConfirmRejectionDialog from 'views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ConfirmRejectionDialog';

const BmApprovalAction = ({ updateStatus, transferOutAppId, id }) => {
    const [updateStatusInfo, setUpdateStatusInfo] = useState(null)
    
    return (
        <Card style={{ width: "inherit", height: "auto", width:'400px', marginLeft: "24px" }}>
            <CardBody>
                <div className='d-flex flex-column' style={{gap:'24px'}}>
                <div className="dark-text label-color">Request actions</div>
                <div className="regular-bold color-grey-60">Please take an action for this request. If you want some changes you can always send it back for correction.</div>
                <div className='d-flex flex-column' style={{gap:'8px'}}>
                <AButton
                    variant="danger_filled"
                    size="xs"
                    className="no-ml-btn"
                    onClick={() => setUpdateStatusInfo({
                        approvalAction: "REJECT",
                        applicationId: transferOutAppId,
                        dialgoInfo: {}
                    })}
                >
                    Reject
                </AButton>

                <AButton
                    variant="primary_filled"
                    size="xs"
                    className="no-ml-btn"
                    onClick={() => updateStatus({
                        approvalAction: "APPROVE",
                        applicationId: transferOutAppId,
                    })}
                >
                    Apporve
                </AButton>

                <AButton
                    variant="outline"
                    textColor={"#000"}
                    className="no-ml-btn"
                    outlineVariantColor={"#CCC"}
                    size="xs"
                    onClick={() => setUpdateStatusInfo({
                        approvalAction: "CORRECTION",
                        applicationId: transferOutAppId,
                        dialogInfo: {
                            heading: "Send back for correction",
                            subHeading: `Request No : ${id}`,
                            proceedBtn: <button style={{ backgroundColor: '#00B0F5', width: 'fit-content', color: '#FFF', border: 'none' }}>Send back for correction</button>
                        }

                    })}
                >
                    Send for Correction
                </AButton>
                </div>
                </div>
                

                <ConfirmRejectionDialog
                    updateStatusInfo={updateStatusInfo}
                    setUpdateStatusInfo={setUpdateStatusInfo}
                    updateStatus={updateStatus}
                    dialogInfo={updateStatusInfo?.dialogInfo}
                />
            </CardBody>
        </Card>
    )
}

export default BmApprovalAction